





import { Component, Vue, Prop } from "vue-property-decorator";
@Component
export default class Label extends Vue {
  @Prop({ default: "#d62418" })
  private background!: string;
  @Prop({ default: "#fffefe" })
  private color!: string;
}
